import { AttachmentOutlined } from "@mui/icons-material";
import { Divider } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useFileDocGroupAndTypesHook } from "../../_src_shared/hooks/useFileDocGroupAndTypesHook";
import RffImportBorrowerDocumentsFromReduxButton from "../../components/finalForm/features/RffImportBorrowerDocumentsFromReduxButton";
import RffFileUploadField from "../../components/finalForm/inputs/RffFileUploadField";
import RffGroup from "../../components/finalForm/shared/RffGroup";
import TitledLoanSection from "./TitledLoanSection";

const FileUploadSection = ({ returnChildrenOnly }) => {
  const { formatDocTypeLabel } = useFileDocGroupAndTypesHook({});

  return (
    <TitledLoanSection
      variant="h2"
      returnChildrenOnly={returnChildrenOnly}
      icon={<AttachmentOutlined className="thin" />}
      headerEndContent={<RffImportBorrowerDocumentsFromReduxButton />}
      title="File Upload"
      cardSx={{
        "& .titled-group-body-root": {
          paddingLeft: 0.5,
        },
      }}
    >
      <RffGroup
        suppressBottomMargin
        headerSx={{ mb: 3 }}
        title="Property Related Documents"
        description="Upload any relevant documents pertaining to the property."
      >
        <RffFileUploadField
          size={6}
          suppressButton
          label={"Scope of Work"}
          docType={"Scope of Work"}
          docGroup={"Construction Documents"}
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          suppressButton
          label={"Purchase Contract"}
          height="120px"
          docGroup={"Property Documents"}
          docType={"Purchase Contract"}
          borderSize={2}
        />
      </RffGroup>
      {/* <Divider sx={{ my: 2, borderColor: grey[200] }} /> */}
      <Divider sx={{ my: 6, borderColor: grey[200] }} />
      <RffGroup
        suppressBottomMargin
        title="Upload Related Entity Documents"
        headerSx={{ mb: 3 }}
        description="Upload any relevant documents pertaining to the entity."
        columnSpacing={5}
      >
        <RffFileUploadField
          size={6}
          label={"Articles of Organization"}
          docType={"Articles of Organization"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          label={formatDocTypeLabel("COGS")}
          docType={"COGS"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          label={formatDocTypeLabel("EIN")}
          docType={"EIN"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
        <RffFileUploadField
          size={6}
          label={"Operating Agreement"}
          docType={"Operating Agreement"}
          docGroup={"Entity Docs"}
          suppressButton
          height="120px"
          borderSize={2}
        />
      </RffGroup>
      <Divider sx={{ my: 6, borderColor: grey[200] }} />
      <RffGroup
        title="Additional Supporting Documents"
        description="If you have any additional documents related to this loan please upload them below"
        // description="If you have any additional documents that are related to this loan, please upload them below"
        suppressBottomMargin
        // headerEndContent={<RffImportBorrowerDocumentsFromReduxButton />}
        columnSpacing={5}
      >
        <RffFileUploadField
          // label={"Additional Related Documents"}
          height="120px"
          suppressButton
          excludeDocGroups={["Entity Docs"]}
          excludeDocTypes={["Purchase Contract", "Scope of Work"]}
          borderSize={2}
          suppressIcon
        />
      </RffGroup>
    </TitledLoanSection>
  );
};

export default FileUploadSection;
